import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { captureAffiliateCodeFromSearch } from '../../utils/affiliate-code'

export default function AffiliateCodeCapture(): null {
  const location = useLocation()
  useEffect(() => {
    captureAffiliateCodeFromSearch(location.search)
  }, [location.search])
  return null
}
